import { type ComponentProps, forwardRef, useState } from 'react'
import type { TextInput } from 'react-native'
import { Input } from '@/src/components/ui/forms/inputs/Input'
import { Ionicons } from '@expo/vector-icons'
import { useMaskedInputProps } from 'react-native-mask-input'
import type { MaskArray } from 'react-native-mask-input/src/formatWithMask.types'
import * as Sentry from '@sentry/react-native'
import { mesaColorNames } from '@/src/common/theme'

interface SSNInputProps extends Omit<ComponentProps<typeof Input>, 'value' | 'onChange'> {
  value: string
  onChange: (masked: string, unmasked: string, obfuscated: string) => void
}

const ssnMask = [
  [/\d/],
  [/\d/],
  [/\d/],
  '-',
  [/\d/],
  [/\d/],
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
] as const satisfies MaskArray

export const InputSsn = forwardRef<TextInput, SSNInputProps>(
  ({ onChange, value, placeholder, ...restOfProps }, ref) => {
    const [showMaskedValue, setShowMaskedValue] = useState(true)

    const maskedInputProps = useMaskedInputProps({
      value,
      showObfuscatedValue: showMaskedValue,
      mask: ssnMask,
      obfuscationCharacter: '*',
      onChangeText: onChange,
    })

    const rightIcon2 = showMaskedValue ? (
      <Ionicons
        name="eye-off-outline"
        type="ionicon"
        color={mesaColorNames['semantic/fg/subtle #898D8F']}
        onPress={() => setShowMaskedValue(false)}
        size={24}
      />
    ) : (
      <Ionicons
        name="eye-outline"
        type="ionicon"
        color={mesaColorNames['semantic/fg/subtle #898D8F']}
        onPress={() => setShowMaskedValue(true)}
        size={24}
      />
    )

    return (
      <Sentry.Mask>
        <Input
          {...restOfProps}
          {...maskedInputProps}
          rightIcon={rightIcon2}
          placeholder={placeholder}
          keyboardType="numeric"
          ref={ref}
        />
      </Sentry.Mask>
    )
  },
)

export default InputSsn
